import { LocationScope, LocationVarInheritance, LocationVarKey, MergedLocationVar } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";
import { useEffect } from "react";
import React from "react";
import { useAutosave } from "react-autosave";

import { Visibility, classNameForRow } from "../../../Hooks/WorksheetRow.Hooks";
import { TagInput, TagInputType } from "../../TagInput/TagInput";
import { WorksheetComponentLabel } from "../Components/Label/WorksheetComponent.Label";
import { WorksheetComponentSwitch } from "../Components/WorksheetComponent/WorksheetComponent.Switch";
import { InternalWorksheetComponentProps } from "../WorksheetComponent/WorksheetComponent.Component";
import { SwitchRow } from "../WorksheetComponent/WorksheetComponents";
import "./WorksheetComponentTextAreaRow.scss";

// interface Props extends WorksheetRow {
//     className?: string
//     varKey:LocationVarKey
//     label?:string
//     enableSwitchVar?:Var
//     placeholder?:string

// }

interface Props {
  label?: string;
  variable: MergedLocationVar;
  switchVariable?: MergedLocationVar;
  enableSwitchVar?: LocationVarKey;
  className?: string;
  visibility?: Visibility;
  // value: string;
  // variable: MergedLocationVar;
  // id: number;
  // value: string;
  // inheritance: LocationVarInheritance;
  // varKey: LocationVarKey;
  type: LocationScope;
  controlType: "input" | "textarea";
  isEditing: boolean;

  disableReverting?: boolean;
  saveVariable: (value: string) => void;
  saveSwitchVar: (value: string) => void;
  customize(): void;
  deleteVariable(): void;
  isLoading: boolean;

  propsForSwitch?: InternalWorksheetComponentProps;
}

export const WorksheetComponentTextAreaRow: React.FC<Props> = (props: Props) => {
  const {
    label,
    type,
    variable,
    isEditing,
    disableReverting,
    saveVariable,
    deleteVariable,
    className,
    visibility,
    enableSwitchVar,
    saveSwitchVar,
    switchVariable,
    propsForSwitch,
    customize,
  } = props;

  const [value, setValue] = React.useState<string>(variable.value);

  useEffect(() => {
    setValue(variable.value);
  }, [variable.inheritance]);

  useEffect(() => {
    setValue(value);
  }, [value]);
  useAutosave({
    data: value,
    onSave: (v) => {
      if (v !== variable.value) {
        saveVariable(v);
      }
    },
  });

  const isEnabled = true; // ( visibility !== Visibility.DISABLED && (!enableSwitchVar || (enableSwitchVar && variables[enableSwitchVar] === "1") || !variables[enableSwitchVar]))? true : false

  return (
    <div className={className}>
      {isEditing ? (
        variable.inheritance === LocationVarInheritance.NONE ? (
          // <div className="textAreaBg">

          <TagInput type={TagInputType.Bubble} value={value} onChange={(e) => setValue(e.target.value)} />
        ) : (
          // </div>
          <div className="textAreaBg customizable" onClick={props.customize}>
            <div className="valueText parentText">{value}</div>
            <div className="customizeOverlay">Click to Customize</div>
          </div>
        )
      ) : (
        <div className="textAreaBg">
          <div className="valueText">{value}</div>
        </div>
      )}

      <div className="WorksheetComponent controls">
        <WorksheetComponentLabel
          key={variable.inheritance + variable.key + variable.id}
          text={label}
          inheritance={variable.inheritance}
          isEditing={isEditing}
          type={type}
          canRevert={!disableReverting}
          isLoading={props.isLoading}
          deleteVariable={deleteVariable}
          inline={false}
        />
        {propsForSwitch && enableSwitchVar && visibility && switchVariable && (
          <WorksheetComponentSwitch
            className={classNameForRow("SwitchRow", propsForSwitch, visibility)}
            key={"s_" + variable.key + "_" + propsForSwitch.path + "_switch"}
            variable={switchVariable}
            // value={variable.value}
            // inheritance={variable.inheritance}
            isLoading={false}
            customize={customize}
            deleteVariable={deleteVariable}
            // id={variable.id}
            // varKey={variable.key as LocationVarKey}
            saveVariable={saveSwitchVar}
            type={props.type}
            isEditing={props.isEditing}
          />
        )}
        {/* {enableSwitchVar && <Switch

              on={isEnabled }
              name="disableSwitch"
              onSet= {(  on) => {
                
                saveSwitchVar( on ? "0" : "1")
              }}
            /> }
 */}
      </div>
    </div>
  );
};
